import api from "../services/api";
import {apiUrl} from "../services";
import {SendNotificationError} from "../helpers/notificationHelper";
import {GetMessage} from "../helpers/errorHelper";
import {getLocaleHash} from "../core/localization/localizationHelper";
import {LocaleType} from "../core/localization/intertace";
import {defaultLocalCode} from "../core/localization/defaults";
import {isBlank} from "../helpers/stringHelper";
import dayjs from "dayjs";
import {isArrayHaveItem} from "../helpers/listHelper";

const CACHE_KEY = (lang: string) => `lang_live_cache_${lang}`;
const HASH_KEY = (lang: string) => `lang_live_hash_${lang}`;
export const LOADING_MESSAGE = "___loading___";

let memoryCache: Record<string, string> = {};
let queue: Set<string> = new Set();
let isSending = false;
let currentLang = defaultLocalCode;
let debugMode = false;
let flushLock = false;
const listeners: Map<string, Map<string, () => void>> = new Map();
export let lastFlushLocaleUpdateTime = dayjs().toDate();
export let hasQueueWord = false;

export function setLiveLang(lang: string):boolean {
    if(!isBlank(lang)){
        currentLang = lang;
        let stored = localStorage.getItem(CACHE_KEY(lang));
        if(stored  === undefined || stored === null){
            stored  = JSON.stringify({});
            localStorage.setItem(CACHE_KEY(lang),stored);
            
        }
        memoryCache = stored ? JSON.parse(stored) : {};
        return true;
    }else{
        return  false;
    }
}

export function setDebugMode(enabled: boolean) {
    debugMode = enabled;
}

export function t(key: string): string {
    if (isBlank(key)) return "";

    // Manuel olarak çevrilmemesi istenen key
    if (key.startsWith("#")) return key;

    // Memory'de varsa ve boş değilse direkt ver
    const fromCache = memoryCache[key];
    if (fromCache !== undefined) {
        return fromCache; // Boş string bile olabilir ama cache'te varsa döneriz
    }

    // Memory'de hiç yoksa → yükleniyor gibi davran
    addToQueue(key);

    // Bekleme mesajı: debugMode aktifse key'i göster, değilse "..." veya özel text
    if (debugMode) {
        return `#${key}#`; // geliştirici gözüyle: "çeviri yok"
    } else {
        return LOADING_MESSAGE; // veya "..." ya da "Loading..."
    }
}



export function subscribeToKey(key: string, subscriberId: string, callback: () => void) {
    if (!listeners.has(key)) listeners.set(key, new Map());
    listeners.get(key)!.set(subscriberId, callback);
}

export function unsubscribeFromKey(key: string, subscriberId: string) {
    listeners.get(key)?.delete(subscriberId);
}

function notifyListeners(key: string) {
    const subs = listeners.get(key);
    if (subs) {
        subs.forEach((cb) => cb());
    }
}
export async function setHashIfNeeded(lang: LocaleType,isLogin:boolean = true):Promise<{ change:boolean,langHash:string|null}> {
    const localHash = localStorage.getItem(HASH_KEY(lang));

    let change:boolean = false;
    let tempHash:string|null= localHash;
    try {
        if(isLogin){
            const newHash = await getLocaleHash(lang);
            if (!localHash || newHash !== localHash) {
                memoryCache = {};
                change = true;
                localStorage.removeItem(CACHE_KEY(lang));
                if (newHash) {
                    localStorage.setItem(HASH_KEY(lang), newHash);
                    tempHash = newHash;
                } else {
                    console.error("Hash fetch error: Hash is undefined");
                }
            }
        }else{
            memoryCache = {};
            change = true;
        }

    } catch (e) {
        console.error("Hash fetch error:", e);
    }

    return {change,langHash:tempHash};
}

function addToQueue(key: string) {
    if (flushLock) {
        let attempts = 0;
        const maxAttempts = 100;
        const interval = setInterval(() => {
            if (!flushLock || attempts >= maxAttempts) {
                queue.add(key);
                hasQueueWord = true;
                clearInterval(interval);
            }
            attempts++;
        }, 10);
    } else {
        hasQueueWord = true;
        queue.add(key);
    }
}

export async function flushQueue():Promise<boolean> {
    if (flushLock || isSending || queue.size === 0) return false;

    flushLock = true;
    isSending = true;

    const words = Array.from(queue);
    hasQueueWord = false;
    queue.clear();

    let change:boolean = false;
    try {
        const res = await api.post(apiUrl.yonetim.dil + "getStrings", words);
        if (res.status === 200) {
            const result: string[] = res.data?.value || [];
            if(isArrayHaveItem(memoryCache)){
                change = true;
            }
            result.forEach((v, i) => {
                const key = words[i];
                const translation = v || `#${key}#`;
                memoryCache[key] = translation;
                notifyListeners(key);
            });


            lastFlushLocaleUpdateTime = dayjs().toDate();
            localStorage.setItem(CACHE_KEY(currentLang), JSON.stringify(memoryCache));
        }
    } catch (e) {
        SendNotificationError(GetMessage(e));
    } finally {
        isSending = false;
        flushLock = false;
    }
    return  change;
}
export function clearLiveLangCache(lang?: string) {
    const targetLang = lang || currentLang;
    memoryCache = {};
    localStorage.removeItem(CACHE_KEY(targetLang));
    localStorage.removeItem(HASH_KEY(targetLang));

    console.warn(`[LiveDictionary] Cache cleared for: ${targetLang}`);
}
export function getAllCached() {
    return memoryCache;
}
